import contractorService from "../../../services/ticketService/contractorService";
import { ContractorInterface } from "../../../models/TicketModule/Contractor";
import { CACHE_KEY_CONTRACTORS } from "../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface AddContractorsContext {
  previousContractors: ContractorInterface[];
}

const useAddConcractors = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    ContractorInterface,
    Error,
    ContractorInterface,
    AddContractorsContext
  >({
    mutationFn: contractorService.Save,

    onMutate: () => {
      const previousContractors =
        queryClient.getQueryData<ContractorInterface[]>([
          CACHE_KEY_CONTRACTORS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousContractors };
    },

    onSuccess: (saveConcractor) => {
      queryClient.setQueryData<ContractorInterface[]>(
        [
          CACHE_KEY_CONTRACTORS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (concractors) =>
          concractors ? [saveConcractor, ...concractors] : [saveConcractor]
      );
    },

    onError: (error, newConcractor, context) => {
      if (!context) return;

      queryClient.setQueryData<ContractorInterface[]>(
        [
          CACHE_KEY_CONTRACTORS,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousContractors
      );
    },
  });
};

export default useAddConcractors;
